module.exports = __webpack_public_path__ + "img/big3-3.fe61324d.jpg";